export default "__VITE_ASSET__B$v$P$7c__"